import { render, staticRenderFns } from "./CommunityUsers.vue?vue&type=template&id=1d1ae470&scoped=true&"
import script from "./CommunityUsers.vue?vue&type=script&lang=ts&"
export * from "./CommunityUsers.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityUsers.vue?vue&type=style&index=0&id=1d1ae470&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1ae470",
  null
  
)

export default component.exports